/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import Application from '../config/application';
import { PageUrl } from '../Constants';
import { formatDate } from '../Util';


const Footer = () => {
  return (
    <footer id="footer">


      <div className="container pt-4">
        <div className="row justify-content-between">
          <div className="col-md-5 mb-4 mb-md-0">
            {/* <p>We support</p> */}

            {/* <img
              src={`${Application.STORAGE_URL_STATIC_ASSETS_PATH
                }/logo-${Application.ORG.toLowerCase()}.png`}
              alt={Application.ORG_DISPLAY_NAME}
              width={200}
            /> */}

            {Application.DISCLAIMER ? (
              <>
                <h2 className="text-white mb-0 ">Disclaimer</h2>
                <p className="copyright-text"> {Application.DISCLAIMER}</p>
              </>
            ) : null}
            {/* <ul className="payments-types">
              <li>
                <img
                  data-toggle="tooltip"
                  src={require('../images/payment/visa.png').default}
                  alt="visa"
                  title="Visa"
                />
              </li>
              <li>
                <img
                  data-toggle="tooltip"
                  src={require('../images/payment/discover.png').default}
                  alt="discover"
                  title="Discover"
                />
              </li>
              <li>
                <img
                  data-toggle="tooltip"
                  src={require('../images/payment/american.png').default}
                  alt="american express"
                  title="American Express"
                />
              </li>
              <li>
                <img
                  data-toggle="tooltip"
                  src={require('../images/payment/mastercard.png').default}
                  alt="mastercard"
                  title="Mastercard"
                />
              </li>
            </ul> */}
          </div>

          <div className="col-md-3 mb-3 mb-md-0">
            {/*<p>
              Please subscribe to our newsletter to get notified about our
              latest offers
            </p>
            <div className="input-group newsletter">
              <input
                className="form-control"
                placeholder="Your Email Address"
                name="newsletterEmail"
                id="newsletterEmail"
                type="text"
              />
              <span className="input-group-append">
                <button className="btn btn-secondary" type="submit">
                  Subscribe
                </button>
              </span>{' '}
  </div>*/}
            <h2 className='text-white mb-0'>Quick Links</h2>

            <ul className="nav justify-content-center flex-column">

              <li className="nav-item">
                {' '}
                <RouterLink className="nav-link" to={PageUrl.ABOUT}>
                  About Us
                </RouterLink>{' '}
              </li>

              <li className="nav-item">
                {' '}
                <RouterLink className="nav-link" to={PageUrl.PRIVACY}>
                  Privacy Policy
                </RouterLink>{' '}
              </li>
              <li className="nav-item">
                {' '}
                <RouterLink className="nav-link" to={PageUrl.TERMS}>
                  Terms & Condition
                </RouterLink>{' '}
              </li>
              <li className="nav-item">
                {' '}
                <RouterLink
                  className="nav-link"
                  to={PageUrl.CANCEL_REFUND_POLICY}>
                  Cancel & Refund Policy
                </RouterLink>{' '}
              </li>

            </ul>
          </div>

          <div className="col-sm-4 col-md-3 Add_Tollfree">
            <h2 className='text-white'>Have Questions?</h2>
            <h5 class="text-color">
              <a href={`tel:${Application.SUPPORT_PHONE}`}>
                <i className="fa fa-phone" aria-hidden="true"></i>
                {Application.SUPPORT_PHONE}
              </a>
            </h5>
            <p>
              {Application.ORG_ADD_LINE1}
              <br />
              <span>{Application.ORG_ADD_LINE2}</span>
            </p>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="footer-copyright">



          <p className="copyright-text">
            Copyright © {formatDate(new Date(), 'yyyy')}{' '}
            {Application.ORG_DISPLAY_NAME}. All Rights Reserved.
          </p>

        </div>
      </div>

      <div className="phone-sticky-footer">
        <div className="Markup phonefooter">
          <div className="footerphonetag">CALL US FOR UNPUBLISHED DEALS</div>
          <div className="container">
            <div classNmae="mt-6">
              <span id="footer_href" className="footer-text-call">{Application.SUPPORT_PHONE}</span></div>
            <div classNmae="mt-6">
              <a href={`tel:${Application.SUPPORT_PHONE}`} id="btn_footer_text_call" className="button btn-small yellow">Call Now</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
